
import { xCore } from './core';
import { NSControlsState } from './utils/controls_state';
import { NSFunctions } from './utils/functions';
import { NSCombos } from './utils/combos';
import { NSMessages } from './utils/messages';
import { NSServerCalls } from './utils/servercalls';
import { URN as NSURN } from './utils/urn';
import { NSPageLabels } from './page_labels';
import { NSDataModelInfo } from './data_model_info';
import { NSGroups } from './groups';
import { NSUserFunctionPermissions } from './user_function_permissions';
import { Map as Module_Map } from './map';
import { NSToolDraw } from './tool_draw';

import CloudDownloadIcon from 'bootstrap-icons/icons/cloud-download.svg?raw'
 
export let NSExport = {};

NSExport.init = function()
{
    NSExportPrivate.init();
	
	this.f_show = 	function () { return NSExportPrivate.f_show.apply( NSExportPrivate, arguments ); };
	
	NSExportPrivate.objs.init();

	this.objs = NSExportPrivate.objs;

	//window.NSExport = NSExport;
	window.NSExport_ = NSExport;
	window.NSExportPrivate_ = NSExportPrivate;
	
}

/*
AQUIIIIIIIIIIIIIIIII TO DO TODO
    SUBSTITUIR EM TODO O CLIENTE data_set_internal_name POR schema_internal_name


*/

let NSExportPrivate =
{
    private_objs: {
		
		settings: null, //config settings
		
		b_comboboxes_already_initialized: false,

		s_e_div_export_holder_id: "exportpage",
		e_div_export_holder: null,
		
		e_select_export_group: null,
		e_select_export_layer: null,
		e_select_export_format: null,
		e_select_export_area: null,
		e_button_export_execute: null,
		e_div_export_loading: null,
		e_span_export_messages: null,
		
		e_div_export_result: null,
		
		o_combo_group: null,
		o_combo_layer: null,
		o_combo_format: null,
		o_combo_area: null,
		
		
		o_data_struct: {
			a_export_format_desc: ["DXF", "SHP"],
            a_export_format_key: ["dxf", "shape-zip"],
			a_export_area_desc: ["Mapa", "Área"],
            a_export_area_key: ["map", "area"],
			a_export_branch: [], //[NSExportPrivate.objs.ExportBranch]
			
			//functions:

			f_generate_data_struct: function ()
			{
				
				let o_ft_export = NSUserFunctionPermissions.f_get_function_type_READ();
				
				if(o_ft_export!=null && o_ft_export.a_collection!=null)
				{
					let a_export_collection = o_ft_export.a_collection;
                    a_export_collection.forEach(o_c_i => 
                    {
                        let s_schema_internal_name = o_c_i.data_set_internal_name;
                        let s_table_internal_name = o_c_i.collection_internal_name;
                        /*
                            returns group: 
                            {
                                external_name,
                                order
                            } -> group object, comes from:
                                    NSUserFunctionPermissions.private_objs.o_func_permissions.a_function_type[...objs.FunctionType].a_collection[...objs.Collection].group
                        */
                        let o_group = NSGroups.f_get_group_by_collection_dataset_and_collection____for_EXPORT(s_schema_internal_name, s_table_internal_name);
                        
                        /*
                            if o_group == null
                                -> collection has not a group configured on the database, therefore will not available
                        */
                        if(o_group != null)
                        {
                            var s_group_id = o_group.external_name;	// on this context the group external_name will be the object "id"
                            
                            //if already exists, get export branch:
                            var o_eb = this.f_get_export_branch_by_id(s_group_id);
                            if(o_eb == null)
                            {
                                var o_in_eb = 
                                {
                                    id: s_group_id,
                                    external_name: o_group.external_name,
                                    order: o_group.order
                                };
                                o_eb = new NSExportPrivate.objs.ExportBranch(o_in_eb);
                                this.a_export_branch.push(o_eb);
                            }
                            
                            //creating Export Collection
                            var o_in_ec = 
                            {
                                id: o_c_i.id, 
                                geometry_field: o_c_i.geometry_field, 
                                data_set_external_name: o_c_i.data_set_external_name, 
                                data_set_internal_name: o_c_i.data_set_internal_name, 
                                collection_external_name: o_c_i.collection_external_name, 
                                collection_internal_name: o_c_i.collection_internal_name
                            }
                            var o_ec = new NSExportPrivate.objs.ExportCollection(o_in_ec);
                            o_eb.a_collection.push(o_ec);
                        }
                        
                        
                        
                    });
					
				}
				
				
				
			},
			
			f_get_export_branch_by_id: function(id)
			{
				var a_ = this.a_export_branch;
				
				for(var i=0; i<a_.length; i++)
				{
					var o_i = a_[i];
					if(o_i.id == id)
					{
						return o_i;
					}
				}
				
				return null;
			},
/*			f_get_export_collection_by_branch_id_and_collection_id: function(i_branch_id, i_collection_id) AQUIIIIIIIIIIIIII
			{
				var o_branch = this.f_get_export_branch_by_id(i_branch_id);
				
				if(o_branch != null )
				{
					var o_collection = o_branch.f_get_branch_collection_by_collection_id(i_collection_id);
					return o_collection;
				}
				
				return null;
			},*/
			f_sort: function()
			{
				var a_ = this.a_export_branch;
				
				var f_eb_cb = function(o_a,o_b){
					
					var i_a_order = (parseInt(o_a.order))? parseInt(o_a.order) : "Not a number";
					var i_b_order = (parseInt(o_b.order))? parseInt(o_b.order) : "Not a number";
					
					if(i_b_order == "Not a number")
					{
						return -1;
					}
					else if(i_a_order == "Not a number")
					{
						return 1;
					}
					else if(i_a_order>=i_b_order)
					{
						return 1;
					}
					else
					{
						return -1;
					}
				}
				a_.sort(f_eb_cb);
				
				for(var i=0; i<a_.length; i++)
				{
					var o_c_i = a_[i];
					o_c_i.f_sort();
				}
			},
			
			/*
			returns:
				{
					a_key,
					a_desc
				}
			*/
			f_get_export_branch_combo_data: function()
			{
				var a_key = [];
				var a_desc = [];
				var a_ = this.a_export_branch;
				
				for(var i=0; i<a_.length; i++)
				{
					var o_i = a_[i];
					a_key.push(o_i.id);
					a_desc.push(o_i.external_name);
					
					//order
				}
				
				return {
					a_key: a_key,
					a_desc: a_desc
				};
			}
			
		}
		
		
	},

    init: function()
	{
		var moduleName = "NSExport";
//		this.private_objs.settings = xCore.loader.modules[moduleName].settings;     AQUIIIIIIIII TODO TO DO
		
		this.objs.init();
		
		var private_objs = this.private_objs;
		private_objs.e_div_export_holder = document.getElementById(private_objs.s_e_div_export_holder_id);
		
		
		this.f_create_page_html();
		
		private_objs.o_data_struct.f_generate_data_struct();
		private_objs.o_data_struct.f_sort();
		
		//this.f_initialize_combos();
	},
	
	f_show: function()
	{
		if( !this.private_objs.b_comboboxes_already_initialized )
		{
			this.f_initialize_combos();
			this.private_objs.b_comboboxes_already_initialized = true;
		}
	},
	f_hide: function()
	{

	},
	f_show_export_loading: function()
	{
		this.private_objs.e_div_export_loading.style.display = "";
	},
	f_hide_export_loading: function()
	{
		this.private_objs.e_div_export_loading.style.display = "none";
	},
	
	
	f_create_page_html: function()
	{
		var this_ = this;
		var private_objs = this.private_objs;

        
		let s_label_export_title = NSPageLabels.f_get_label_text_by_internal_name("label_export_title");
		let s_label_export_combobox_group_label = NSPageLabels.f_get_label_text_by_internal_name("label_export_combobox_group_label");
		let s_label_export_combobox_table_label = NSPageLabels.f_get_label_text_by_internal_name("label_export_combobox_table_label");
		let s_label_export_combobox_format_label = NSPageLabels.f_get_label_text_by_internal_name("label_export_combobox_format_label");
		let s_label_export_combobox_area_label = NSPageLabels.f_get_label_text_by_internal_name('label_export_combobox_area_label');
		let s_label_export_button_excute_tooltip = NSPageLabels.f_get_label_text_by_internal_name("label_export_button_excute_tooltip");
		
		var s_html = `
			<div class="page-title">${s_label_export_title}</div>
			<div class="page-content">
				<div class="page-card">
					<div class="form">
						<div class="row g-0">
							<div class="col-12 col-sm-4">	
								<span for="select_export_group">${s_label_export_combobox_group_label}: </span>
							</div>
							<div class="col-12 col-sm-8">	
								<select id="select_export_group" class="form-select form-select-sm"></select>
							</div>
						</div>
						<div class="row g-0">
							<div class="col-12 col-sm-4">	
								<span for="select_export_layer">${s_label_export_combobox_table_label}: </span>
							</div>
							<div class="col-12 col-sm-8">	
								<select id="select_export_layer" class="form-select form-select-sm"></select>
							</div>
						</div>
						<div class="row g-0">
							<div class="col-12 col-sm-4">	
								<span for="select_export_format">${s_label_export_combobox_format_label}: </span>
							</div>
							<div class="col-12 col-sm-8">	
								<select id="select_export_format" class="form-select form-select-sm"></select>
							</div>
						</div>
						<div class="row g-0"> 
							<div class="col-12 col-sm-4">	
								<span for="select_export_area">${s_label_export_combobox_area_label}: </span>
							</div>
							<div class="col-12 col-sm-8">	
								<select id="select_export_area" class="form-select form-select-sm"></select>
							</div>
						</div>
					</div>
					<div class="actions">	
						<div id="div_export_result"></div>
						<span id="span_export_messages" class=""></span>
						<div id="div_export_loading" class="spinner-border text-danger" role="status"></div>
						<button id="button_export_execute" type="button" class="btn btn-sm btn-outline-secondary" title="${s_label_export_button_excute_tooltip}">
							${CloudDownloadIcon}
						</button>
					</div>
				</div>
			</div>
		`;
		
		NSFunctions.f_dom_elem_append_dom_childs_by_html(private_objs.e_div_export_holder, s_html);
		
		private_objs.e_select_export_group = document.getElementById("select_export_group");
		private_objs.e_select_export_layer = document.getElementById("select_export_layer");
		private_objs.e_select_export_format = document.getElementById("select_export_format");
		private_objs.e_select_export_area = document.getElementById("select_export_area");
		private_objs.e_button_export_execute = document.getElementById("button_export_execute");
		private_objs.e_div_export_loading = document.getElementById("div_export_loading");
		private_objs.e_span_export_messages = document.getElementById("span_export_messages");
		
		private_objs.e_div_export_result = document.getElementById("div_export_result");
		//AQUIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIII
		this.f_hide_result_div();

		this.f_hide_export_loading();
	
		//this.f_initialize_combos();
		
		private_objs.e_button_export_execute.onclick = function(){  this_.f_execute_export(); };
		
		
	},

    
	/*
	
	*/
	f_get_export_formats_key: function ()
	{
		var a_export_format_key = this.private_objs.o_data_struct.a_export_format_key;
		return a_export_format_key;
	},
	/*
	
	*/
	f_get_export_formats_desc: function ()
	{
		var a_export_format_desc = this.private_objs.o_data_struct.a_export_format_desc;
		return a_export_format_desc;
	},
	/*
	
	*/
	f_get_server_export_path: function ()
	{
		var s_server_export_path = this.private_objs.settings.server_export_path;
		return s_server_export_path;
	},
	
	
	
	
	f_initialize_combos: function()
	{
		var this_ = this;
		
		var private_objs = this.private_objs;
	
		
		//group:
		var f_onSelect_group_CB = function(s_key)
		{
			this_.f_onSelect_group(s_key);
		}
		
		var s_id_select_export_group = private_objs.e_select_export_group.getAttribute("id");
		private_objs.o_combo_group =  new NSCombos.objs.Combo(s_id_select_export_group, f_onSelect_group_CB, [], null);
		
		//layer:
		var f_onSelect_layer_CB = function(s_key)
		{
			this_.f_onSelect_layer(s_key);
		}
		
		var s_id_select_export_layer = private_objs.e_select_export_layer.getAttribute("id");
		private_objs.o_combo_layer =  new NSCombos.objs.Combo(s_id_select_export_layer, f_onSelect_layer_CB, [], null);
		
		//format:
		var f_onSelect_format_CB = function(s_key)
		{
			this_.f_onSelect_format(s_key);
		}
		
		var s_id_select_export_format = private_objs.e_select_export_format.getAttribute("id");
		private_objs.o_combo_format =  new NSCombos.objs.Combo(s_id_select_export_format, f_onSelect_format_CB, [], null);

		//area:
		var f_onSelect_area_CB = function(s_key)
		{
			this_.f_onSelect_area(s_key);
		}
		
		var s_id_select_export_area = private_objs.e_select_export_area.getAttribute("id");
		private_objs.o_combo_area =  new NSCombos.objs.Combo(s_id_select_export_area, f_onSelect_area_CB, [], null);
		
		//filling group combo
		/*returns: {a_key, a_desc}*/
		var o_branch_combo_data = private_objs.o_data_struct.f_get_export_branch_combo_data();
		private_objs.o_combo_group.reset(o_branch_combo_data.a_desc, o_branch_combo_data.a_key);
		
		//filling format combo:
		var a_export_format_desc = private_objs.o_data_struct.a_export_format_desc;
		var a_export_format_key = private_objs.o_data_struct.a_export_format_key;
		private_objs.o_combo_format.reset(a_export_format_desc, a_export_format_key);
		
		//filling area combo:
		var a_export_area_desc = private_objs.o_data_struct.a_export_area_desc;
		var a_export_area_key = private_objs.o_data_struct.a_export_area_key;
		private_objs.o_combo_area.reset(a_export_area_desc, a_export_area_key);
	},
	f_onSelect_group: function(s_key)
	{
        let this_ = this;
		let private_objs = this.private_objs;
		
		//s_key should already be of type int
		//var i_key = parseInt(s_key);
		let o_eb = private_objs.o_data_struct.f_get_export_branch_by_id(s_key);
		

		let a_s_table_urn = o_eb.f_get_export_table_urn_list();
        //load DataModelInfo for all tables:
		NSDataModelInfo.f_load_table_list____returning_promise(
			{
				a_s_table_urn: a_s_table_urn,
				b_full_info: false
			}
		).then((a_values) => {
			//console.log("---------- export - just called f_load_table_list____returning_promise");
			//console.log("---------- tables loaded: " + a_s_table_urn.toString() );
            
            o_eb.f_update_tables_external_names();

            /* returns: { a_key, a_desc } */
            let o_ec_data = o_eb.f_get_export_collection_combo_data();

            private_objs.o_combo_layer.reset(o_ec_data.a_desc, o_ec_data.a_key);

        });
	},
	f_onSelect_layer: function(s_key){},

	f_onSelect_format: function(s_key){},

	f_onSelect_area: function(s_key) {},

    f_execute_export: function()
	{
		let this_ = this;
		let b_button_active = this.f_button_execute_is_enabled();
		
		if (!b_button_active)
		{
			return;
		}

		this.f_button_execute_disable();
		
		this.f_hide_result_div();
		
		let b_input_is_valid = this.f_validate();
		
		if (b_input_is_valid)			
		{
			
			let f_cb = function(o_res)
			{
				this_.f_button_execute_enable();
				this_.f_hide_export_loading();
				
			};
			
			this.f_show_export_loading();
			this.f_execute_export_part_2(f_cb);
			
		}
		else
		{
			this_.f_button_execute_enable();
		}
		
	},

    f_validate: function()
	{
		let b_res = true;
		let s_area_selected = this.private_objs.o_combo_area.getSelectedKey();
		
		//Geometry Validation
		//user map visible area
		let i_zoom = Module_Map.f_get_map_zoom();

        if(i_zoom < 18)
        {
            b_res = false;
            let s_message = NSPageLabels.f_get_label_text_by_internal_name("label_export_validation_error_visible_area");
            this.f_show_local_message(s_message);
        }

		if (s_area_selected === 'area' && !NSToolDraw_.f_draw_polygon_is_active_and_an_area_is_drawn()) {
			b_res = false;
            let s_message = NSPageLabels.f_get_label_text_by_internal_name("label_export_validation_error_area_drawn");
            this.f_show_local_message(s_message);
		}
		
		return b_res;
	},

    
	f_execute_export_part_2: function(f_cb_in)
	{	
		try {
			let private_objs = this.private_objs;
	
			let s_cache_limitation_param_value = NSFunctions.guidGenerator();
			let s_table_internal_name = private_objs.o_combo_layer.getSelectedKey();
			let s_max_fetures = 100000;
			let s_output_format = private_objs.o_combo_format.getSelectedKey();
			let s_area_selected = private_objs.o_combo_area.getSelectedKey();
			
			let a_map_bounds;
	
			if (s_area_selected === 'map') a_map_bounds = Module_Map.f_get_map_bounds();
			if (s_area_selected === 'area') a_map_bounds = NSToolDraw.f_get_drawn_map_feature().getGeometry().getExtent();
	
			if (!a_map_bounds) return f_cb_in();
	
			//let s_url = NSServerCalls.geoserver.wfs.get_export_url(s_table_internal_name, s_max_fetures, a_map_bounds, null, s_cache_limitation_param_value, s_output_format);
			let s_url = NSServerCalls.geoserver.wfs.get_export_url_bbox_using_cql_filter(s_table_internal_name, s_max_fetures, a_map_bounds, null, s_cache_limitation_param_value, s_output_format);
			
			let s_guid = NSFunctions.guidGenerator();
			window.open(s_url, "_new_browsing_context_" + s_guid);
	
			this.f_show_result_div();
			f_cb_in();
		} catch (err) {
			f_cb_in();
		}
    },

    f_button_execute_is_enabled: function()
	{
		let e_button_execute = this.private_objs.e_button_export_execute;
		let b_is_enabled = NSControlsState.f_control_is_enabled(e_button_execute);
		
		return b_is_enabled;
	},
	f_button_execute_enable: function()
	{
		let e_button_execute = this.private_objs.e_button_export_execute;
        NSControlsState.f_control_enable(e_button_execute);
		
	},
	f_button_execute_disable: function()
	{
		let e_button_execute = this.private_objs.e_button_export_execute;
        NSControlsState.f_control_disable(e_button_execute);
		
		
	},

    f_show_local_message: function(s_message)
	{
		//this.private_objs.e_span_export_messages.innerHTML = "<b>" + s_message + "</b>";
        NSMessages.f_show_information(s_message);
	},
	f_show_local_message_error_invoking_service: function ()
	{
		//this.f_show_local_message("Erro ao invocar o serviço.");
        let s_message = NSPageLabels.f_get_label_text_by_internal_name("common_error_executing_service");
        NSMessages.f_show_error(s_message);
	},
	
    f_show_result_div: function()
	{
		this.private_objs.e_div_export_result.style.display = 'inline';
	},
	f_hide_result_div: function()
	{
		this.private_objs.e_div_export_result.style.display = 'none';
	},

    //--------------------------------------------------------------------------------
    //objs section:
	objs: {
		/*
		o_in:
		{
			id
			external_name
			order
		}
		*/
		ExportBranch: function (o_in)
		{
			this.id = o_in.id;
			this.external_name = o_in.external_name;
			this.order = o_in.order;
			this.a_collection = []; //[NSExportPrivate.objs.ExportCollection]
			
		},
		/*
		//NSUserFunctionPermissions.objs.Collection
		
		o_in: { 
			id, 
			geometry_field, 
			data_set_external_name, 
			data_set_internal_name, 
			collection_external_name, 
			collection_internal_name, 
			}
		*/
		ExportCollection : function(o_in)
		{

				this.id = o_in.id;
				this.geometry_field = o_in.geometry_field;
				this.data_set_external_name = o_in.data_set_external_name;
				this.data_set_internal_name = o_in.data_set_internal_name;
				this.collection_external_name = o_in.collection_external_name;
				this.collection_internal_name = o_in.collection_internal_name;
		},
		
		init: function()
		{
/*
			this.ExportBranch.prototype.f_get_branch_collection_by_collection_id = function (id)
			{
				var a_ = this.a_collection;
				for(var i=0; i<a_.length; i++)
				{
					var o_i = a_[i];
					if(o_i.id == id)
					{
						return o_i;
					}
				}
				return null;
				
			};*/
			/*
			returns:
				{
					a_key,
					a_desc
				}
			*/
			this.ExportBranch.prototype.f_get_export_collection_combo_data = function()
			{
				let a_key = [];
				let a_desc = [];
				let a_ = this.a_collection;
				a_.forEach( ( o_i ) =>
                {
                    let s_schema_internal_name = o_i.data_set_internal_name;
                    let s_table_internal_name = o_i.collection_internal_name;
                    let o_geom_field_info = NSDataModelInfo.f_get_table_first_geometry_field_info(s_schema_internal_name, s_table_internal_name);
                    let b_table_has_geometry = (o_geom_field_info!=null)? true : false;

                    if(b_table_has_geometry)
                    {
                        //a_key.push(o_i.id);
                        a_key.push(o_i.collection_internal_name);
                        a_desc.push(o_i.collection_external_name);
					    //order - already ordered
                    }
                });
				
				return {
					a_key: a_key,
					a_desc: a_desc
				};
			};

            this.ExportBranch.prototype.f_get_export_table_urn_list = function()
			{
                let a_s_table_urn = [];

				let a_ = this.a_collection;
				
                a_.forEach( (o_i) =>
                {
                    let s_schema_internal_name = o_i.data_set_internal_name;
                    let s_table_internal_name = o_i.collection_internal_name;

                    let s_table_urn = NSURN.f_create_table_urn(s_schema_internal_name, s_table_internal_name);
                    a_s_table_urn.push(s_table_urn);

                    //order - already ordered
                });
				
				return a_s_table_urn;
			};

            this.ExportBranch.prototype.f_update_tables_external_names = function()
			{
				let a_ = this.a_collection;
				
                a_.forEach( (o_i) =>
                {
                    let s_schema_internal_name = o_i.data_set_internal_name;
                    let s_table_internal_name = o_i.collection_internal_name;

                    let s_table_urn = NSURN.f_create_table_urn(s_schema_internal_name, s_table_internal_name);
                    let o_table_info = NSDataModelInfo.f_get_table_info_by_table_urn(s_table_urn);

                    o_i.collection_external_name = o_table_info.external_name;

                    //order - already ordered
                });

			};
			
			
			this.ExportBranch.prototype.f_sort = function()
			{
				var a_ = this.a_collection;
				
				var f_ec_cb = function(o_a,o_b){
					/*
					var i_a_order = (parseInt(o_a.order))? parseInt(o_a.order) : "Not a number";
					var i_b_order = (parseInt(o_b.order))? parseInt(o_b.order) : "Not a number";
					
					if(i_b_order == "Not a number")
					{
						return -1;
					}
					else if(i_a_order == "Not a number")
					{
						return 1;
					}
					else if(i_a_order>=i_b_order)
					{
						return 1;
					}
					else
					{
						return -1;
					}
					*/
					var s_collection_external_name_a = o_a.collection_external_name;
					var s_collection_external_name_b = o_b.collection_external_name;
					return NSFunctions.o_comparisson_struct.f_text_comparison(s_collection_external_name_a, s_collection_external_name_b);
				}
				
				a_.sort(f_ec_cb);

				
			}
			
		}
		
	}




}
